import * as React from "react";
import { Table, Typography } from "antd";
import { IAdditionalIncome } from "../../../../model/report/applicantdata/AdditionalIncome";
import NumberFormatter from "../../../../model/common/NumberFormatter";

const AdditionalIncomeGrid = ({
  translate,
  data
}: {
  translate?: any;
  data?: IAdditionalIncome[];
}) => {
  const columns = [
    {
      title: translate("report8.document_template.additional_income.name"),
      dataIndex: "name",
      key: "additionalIncomeName"
    },
    {
      title: translate(
        "report8.document_template.additional_income.income_type"
      ),
      dataIndex: "incomeType",
      key: "incomeType"
    },
    {
      title: translate(
        "report8.document_template.additional_income.income_source"
      ),
      dataIndex: "incomeSource",
      key: "incomeSource"
    },
    {
      title: translate("report8.document_template.additional_income.date_from"),
      dataIndex: "dateFrom",
      key: "additionalIncomeDateFrom"
    },
    {
      title: translate("report8.document_template.additional_income.date_to"),
      dataIndex: "dateTo",
      key: "additionalIncomeDateTo"
    },
    {
      title: translate(
        "report8.document_template.additional_income.total_income"
      ),
      key: "totalIncome",
      align: "right" as "right",
      render: (record) => (
        <div>{NumberFormatter().formatReadOnlyValue(record.totalIncome)}</div>
      )
    },
    {
      title: translate(
        "report8.document_template.additional_income.description"
      ),
      dataIndex: "description",
      key: "additionalIncomeDescription"
    }
  ];
  return (
    <div>
      <Typography.Title style={{ fontSize: 12, marginBottom: 20 }}>
        {translate("report8.document_template.additional_income.title")}
      </Typography.Title>
      <Table
        bordered
        dataSource={data}
        columns={columns}
        pagination={false}
        size={"small"}
        locale={{ emptyText: translate("reports.table.no_data") }}
        style={{ marginBottom: 15 }}
      />
    </div>
  );
};

export default AdditionalIncomeGrid;
